<template>
  <card-modal class="available-bridges">
    <template slot="header">
      <h1>Connect <code>{{ serialNumber }}</code> to Balena</h1>
    </template>

    <template slot="content">
      <ion-content>
        <ion-list>
          <ion-item>
            Serial Number: {{ serialNumber }}
          </ion-item>
          <ion-item>
            Admin Client ID: {{ bridge.admin_client_id }}
          </ion-item>
          <ion-item>
            Region: {{ region.get(bridge.region) }}
          </ion-item>
          <ion-item>
            Cloud Region: {{ cloudRegion.get(bridge.cloud_region) }}
          </ion-item>
          <ion-item>
            Mirror Client ID: {{ bridge.mirror_client_id | optional }}
          </ion-item>
          <ion-item>
            Mirror Client Secret: {{ bridge.mirror_client_secret | optional }}
          </ion-item>
        </ion-list>

        <ion-list>
          <ion-item 
            v-for="balenaBridge in bridge.available"
            :key="balenaBridge.id"
          >
            <code class="ion-margin-end">{{ balenaBridge.device_name }}</code> 
            created on {{ balenaBridge.created_at | datetime }}
            
            <ion-button
              slot="end"
              :disabled="busy"
              @click="connect(balenaBridge)"
            >
              <ion-spinner
                v-if="balenaBridge.busy"
                class="small-spinner"
              />
              <template v-else>
                Connect
              </template>
            </ion-button>
          </ion-item>
        </ion-list>

        <!-- <ion-item>
          <ion-label position="floating">Name</ion-label>
          <ion-input-vue v-model="deviceGroup.name" />
        </ion-item> -->
      </ion-content>
    </template>
  </card-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import { region } from '../../bridge/region'
import { modalController } from '@modus/ionic-vue'

import Vue from 'vue'
import CardModal from '../../common/CardModal'

import store from '../../state'
import cloudRegion from '../../bridge/cloudRegion'

export default {
  components: {
    CardModal
  },
  props: {
    serialNumber: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      busy: false,
      region,
      cloudRegion
    }
  },
  computed: {
    ...mapGetters([
      'getInventoryBridgeBySerial'
    ]),
    bridge() {
      return this.getInventoryBridgeBySerial(this.serialNumber)
    }
  },
  created() {
    this.$store = store
  },
  methods: {
    async connect(balenaBridge) {
      this.busy = true
      const localBridge = this.bridge

      Vue.set(balenaBridge, 'busy', true)

      this.$store.dispatch('connectBridgeToBalena', { localBridge, balenaBridge })
        .finally(() => this.busy = false)
        .finally(() => balenaBridge.busy = false)
        .finally(() => modalController.dismiss())
    }
  }
}
</script>

<style>
.available-bridges-modal ion-card-content, .available-bridges-modal ion-content {
  height:100%;
}
</style>